import React, { useMemo, useState, useEffect, useCallback } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import Pagination from "components/common/Pagination";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import ReactTableWrapper from "components/reacttable/reacttbl.style";
import classnames from "classnames";
import { getAllSubscriptionHistory } from "services/usersServices";
import NavigationActions from "redux/navigation/actions";
import { compose } from "redux";
import { updateUserStatus } from "services/merchantAuthServices";

import Loader from "components/Loader";
import { Switch } from "@mui/material";

const { success, error, fetching } = NavigationActions;
let debounceTimer;

const HeaderComponent = props => {
  let classes = {
    "-sort-asc": props.isSortedDesc !== undefined && !props.isSortedDesc,
    "-sort-desc": props.isSortedDesc !== undefined && props.isSortedDesc
  };
  return <div className={classnames(classes)}>{props.title}</div>;
};

const SubscriptionHistories = props => {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageLength, setPageLength] = useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const [sortObject, setSortObject] = useState({ id: "id", desc: false });
  const { token, success, error, fetching, user } = props;
  const [refresh, toggleRefresh] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [totalRecords, setTotalRecords] = useState("0");
  const [isLoad, setLoader] = useState(true);
  const [searchText, setSearchText] = useState("");

  const columns = useMemo(
    () => [
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Transaction Date"
            />
          );
        },
        placeholder: "",
        disableFilters: true,
        accessor: "created_at",
        Cell: tableInstance => (
          <span className="text-capitalize">
            {new Date(tableInstance.row?.original?.created_at).toDateString()}
          </span>
        )
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Full Name"
            />
          );
        },
        placeholder: "Full Name",
        disableFilters: true,
        accessor: "name",
        Cell: tableInstance => (
          <span className="text-capitalize">
            {tableInstance.row?.original?.user_id?.name}
          </span>
        )
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Email"
            />
          );
        },
        placeholder: "Email",
        disableFilters: true,
        accessor: "email",
        Cell: tableInstance => (
          <span className="text-capitalize">
            {tableInstance.row?.original?.user_id?.email}
          </span>
        )
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Package"
            />
          );
        },
        placeholder: "Package_type",
        disableFilters: true,
        accessor: "package_type",
        Cell: tableInstance => (
          <span className="text-capitalize">
            {tableInstance.row?.original?.package_type}
          </span>
        )
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Payment Status"
            />
          );
        },
        disableFilters: true,
        disableSort: true,
        accessor: "user_status",
        Cell: tableInstance => (
          <span className="text-capitalize">
            {tableInstance.row?.original?.payment_status}
          </span>
        )
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Auto Renew"
            />
          );
        },
        placeholder: "autoRenew",
        disableFilters: true,
        accessor: "autoRenew",
        Cell: tableInstance => (
          <span className="text-capitalize">
            {tableInstance.row?.original?.autoRenew ? "Yes" : "No"}
          </span>
        )
      }
    ],
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    rows,
    headerGroups,
    state: { sortBy }
  } = useTable(
    {
      data: usersList,
      columns: columns,
      manualSortBy: true,
      initialState: {
        pageSize: pageLength,
        pageIndex: 0
      }
    },
    useSortBy,
    usePagination
  );
  const handleUpdateStatus = async user => {
    setLoader(true);
    let { user_status, _id } = user;
    await updateUserStatus(token, _id, { status: !user_status }).then(res => {
      if (res.success) {
        success(res.message);
        toggleRefresh(true);
        setLoader(false);
      } else {
        error(res.message);
        setLoader(false);
      }
    });
    setLoader(false);
  };

  const callApi = useCallback(async () => {
    const params = {
      page: currentPage + 1,
      limit: pageLength,
      search: searchText,
      sort_on: sortObject.id ? sortObject.id : "createdAt",
      sort:
        sortObject.desc !== undefined
          ? sortObject.desc
            ? "desc"
            : "asc"
          : "desc"
      // sortBy: sortObject,
    };

    await getAllSubscriptionHistory(token, params).then(data => {
      fetching();
      if (data.success) {
        console.log(data, "data");
        setUsersList(data.data.docs);
        setTotalRecords(data.data.totalDocs);
        setTotalPage(data.data.totalPages);
        toggleRefresh(false);
        success();
        setLoader(false);
      } else {
        error(data.message);
        setLoader(false);
      }
    });
    // eslint-disable-next-line
  }, [currentPage, pageLength, sortObject, refresh, searchText]);
  useEffect(() => {
    // Call api here
    if (debounceTimer) {
      clearTimeout(debounceTimer);
      debounceTimer = null;
    }
    debounceTimer = setTimeout(() => {
      // setPageLength(10);
      callApi();
    }, 1000);
  }, [currentPage, sortObject, callApi]);

  useEffect(() => {
    // Call api here
    setCurrentPage(0);
  }, [sortObject, pageLength]);

  useEffect(() => {
    setSortObject({ ...sortBy[0] });
  }, [sortBy]);

  const handlePageChange = page => {
    fetching();
    setCurrentPage(page);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row title-sec align-items-center">
          <div className="col-sm headline">Transactions</div>
          <div className="col-sm-auto ml-auto"></div>
        </div>
        <div className="row align-items-center my-3">
          <div className="col-md-4">
            <div className="icon-form-control">
              <i class="fas fa-search"></i>
              <input
                value={searchText ? searchText : ""}
                onChange={e => {
                  setCurrentPage(0);
                  setSearchText(e.target.value);
                }}
                type="text"
                placeholder="Search users..."
                className="form-control log-form-control react-form-input"
              />
            </div>
          </div>
        </div>
        <div className="div-container">
          <ReactTableWrapper {...props}>
            <div className="table-responsive common-table card-box grey-box mb-2">
              <table className="table border-0" {...getTableProps()}>
                <thead className="thead-color text-center">
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map(header => (
                        <th
                          className="thead-color"
                          {...header.getHeaderProps(
                            header.getSortByToggleProps()
                          )}
                        >
                          <div>{header.render("Header")}</div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()} className="text-center">
                  {isLoad ? (
                    <tr>
                      <td colSpan={4}>
                        <Loader colspan={columns?.length} />
                      </td>
                    </tr>
                  ) : rows.length > 0 ? (
                    rows.map(row => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map(cell => (
                            <td className="td-border" {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td className="td-border" colSpan={columns?.length}>
                        <h6>No Data Found</h6>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="row align-items-center table-footer">
              <div className="col-sm-6 text-center text-sm-left">
                <span className="total-entry">
                  Showing{" "}
                  {usersList.length < pageLength
                    ? totalRecords
                    : currentPage * pageLength + pageLength}{" "}
                  of {totalRecords} entries
                </span>
              </div>
              <div className="col-sm-6">
                <Pagination
                  onPageChange={handlePageChange}
                  pages={totalPage}
                  page={currentPage}
                />
              </div>
            </div>
          </ReactTableWrapper>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user,
    channel: state.navigation.channel
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    success,
    error,
    fetching
  })
)(SubscriptionHistories);
